const e = "collapseEnter_4cW5K", l = "collapseEnterActive_n3iJg", c = "collapseEnterDone_vNvCN", t = "collapseExit_iwvZS", o = "collapseExitActive_SEyXp", s = {
  collapseEnter: e,
  collapseEnterActive: l,
  collapseEnterDone: c,
  collapseExit: t,
  collapseExitActive: o
};
export {
  e as collapseEnter,
  l as collapseEnterActive,
  c as collapseEnterDone,
  t as collapseExit,
  o as collapseExitActive,
  s as default
};
//# sourceMappingURL=collapse.module.scss.js.map
